
import React from 'react';
import Footer from '../components/Footer';
import Slideshow from './Slideshow';



const Acceuil = () => {
    return (
        <div>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>


            <Slideshow />
            <div className="container">
                <br></br>



                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="hero_content">

                                <div className="mb-5">
                                    <span className="top-commentaire">Nive Ramarovelo, votre Réflexologue Certifiée</span>
                                    <p></p>
                                    <span className="top-title">Pourquoi venir?</span>

                                    <p>Pour avoir un moment à soi et pour retrouver équilibre et harmonie</p>

                                    <span className="top-title">Pour qui ? Quand le faire ?</span>

                                    <p>La réflexologie est bénéfique quel que soit l'âge (bébés, enfants, adolescents, adultes et seniors) et quelle que soit l’étape de vie (naissance, puberté, grossesse, ménopause, retraite). </p>
                                    <p>Pour le maintien d’un bon équilibre général, une à deux séances sont bienvenues à chaque changement de saison. Elles aident l’organisme à maintenir ou à retrouver équilibre et bien-être.</p>
                                    <p></p>
                                    <span className="top-title">Pourquoi voir un réflexologue ?</span>
                                    <p>La réflexologie est une méthode naturelle, qui permet d'apporter de l'apaisement, de prendre en compte les différentes manifestations du stress et les troubles qui l'accompagnent, de se reconnecter à son monde intérieur, et finalement, d'aider chacun à se prendre en charge pour améliorer sa santé. C'est une méthode globale.</p>
                                    <p>Elle peut agir sur le stress, les tensions, le sommeil, la digestion, les muscles et articulations, la fatigue, la vitalité ainsi que de nombreux autres troubles, et permet de travailler en prévention des troubles.  </p>
                                </div>

                                <a type="button" className="btn btn-lg btn-primary btn-zoom" href="/reflexologie">En savoir plus</a>
                                <span> </span>
                                <a type="button" className="btn btn-lg btn-primary btn-zoom" href="/apropos">Votre Réflexologue</a></div>
                        </div>
                        <br></br>
                        <br></br>
                        <div className="col-lg-6">
                            <div className="hero_figure">
                                <br></br>
                                <img className="imgpage img-reduced" src="assets/img/accueil_1.jpg" alt="" />

                            </div>
                        </div>
                    </div>
                </div>
                <br></br>
                <br></br>


                <div className="row text-center">
                    <div className="col-lg-6 offset-lg-3">
                        <div className="about_header mb-5">
                            <span className="top-title">SEANCE</span>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="hero_figure">

                                <img className="imgpage img-reduced" src="assets/img/accueil_3.jpg" alt="" />

                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="hero_content">

                                <div className="mb-5">
                                    <span className="top-title">La séance</span>
                                    <p></p>
                                    <span className="top-commentaire">Je vous reçois en cabinet au :
                                        <br></br> - 54, avenue Jean Moulin, 92390 Villeneuve La Garenne.
                                    </span>
                                    <p></p>
                                    <p>Une séance dure environ 1h. Cependant, pour une première séance, prévoyez d’être disponible environ 1h15.</p>
                                    <p></p>
                                    <p>La séance se déroule en 3 temps :</p>
                                    <ol className="list-numbered">
                                        <li><h1 className="top-list">Un temps dédié à l’échange sur vous et vos habitudes de vie, mais aussi sur vos attentes. Ce temps permet de personnaliser le soin pour votre bien être global.</h1></li>
                                        <li><h1 className="top-list">Puis place au soin : fermez les yeux et soyez à l’écoute de vos sensations.</h1></li>
                                        <li><h1 className="top-list">A la fin de la séance, prenez le temps de vous reconnecter au monde extérieur puis partageons sensations et ressentis.</h1></li>

                                    </ol>
                                    <p>Dans le cadre d’un accompagnement structuré et évolutif, il est recommandé de faire 2 à 3 séances rapprochées, puis une séance d’entretien par mois selon la pathologie.</p>

                                </div>

                                <a type="button" className="btn btn-lg btn-primary btn-zoom" href="/tarifs">Tarifs</a></div>
                        </div>

                        <div className="container">
                            <br></br>
                            <br></br>
                            <br></br>
                            <div className="about_header mb-5">
                                <span className="top-title">Conseils</span>

                                <p>Il est vivement conseillé de boire beaucoup d’eau dans les heures qui suivent votre séance afin d’aider votre organisme à éliminer les toxines.</p>
                            </div>
                        </div>


                    </div>
                </div>


            </div>
            <Footer />
        </div>


    );
}

export default Acceuil